<template>
  <transition name="slide-up">
    <div v-if="visible" class="cookie-consent">
      <div class="cookie-consent-inner">
        <p class="cookie-text">
          본 사이트는 서비스 제공 및 사용자 경험 개선을 위해 쿠키와
          Google Analytics를 사용합니다.
          <router-link to="/user/terms" class="cookie-link">
            개인정보 처리방침
          </router-link>
        </p>
        <div class="cookie-actions">
          <button class="cookie-btn cookie-btn-accept" @click="accept">
            동의
          </button>
          <button class="cookie-btn cookie-btn-decline" @click="decline">
            거부
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";

const COOKIE_CONSENT_KEY = "terra-cookie-consent";

export default defineComponent({
  name: "CookieConsent",
  setup() {
    const visible = ref(false);

    onMounted(() => {
      const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
      if (!consent) {
        visible.value = true;
      }
    });

    const accept = () => {
      localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
      visible.value = false;
    };

    const decline = () => {
      localStorage.setItem(COOKIE_CONSENT_KEY, "declined");
      visible.value = false;
    };

    return { visible, accept, decline };
  },
});
</script>

<style scoped>
.cookie-consent {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background-color: var(--t-bg-surface);
  border-top: 1px solid var(--t-border-medium);
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.3);
}

.cookie-consent-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 1rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
}

.cookie-text {
  margin: 0;
  font-size: 0.85rem;
  color: var(--t-text-secondary);
  line-height: 1.5;
}

.cookie-link {
  color: var(--t-accent-primary);
  text-decoration: underline;
}

.cookie-actions {
  display: flex;
  gap: 0.5rem;
  flex-shrink: 0;
}

.cookie-btn {
  padding: 0.5rem 1.2rem;
  border: none;
  border-radius: 6px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.cookie-btn-accept {
  background-color: var(--t-accent-primary);
  color: #fff;
}

.cookie-btn-accept:hover {
  background-color: var(--t-accent-primary-hover);
}

.cookie-btn-decline {
  background-color: transparent;
  color: var(--t-text-tertiary);
  border: 1px solid var(--t-border-medium);
}

.cookie-btn-decline:hover {
  background-color: var(--t-bg-hover);
}

/* slide-up transition */
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.4s ease, opacity 0.4s ease;
}

.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

@media (max-width: 600px) {
  .cookie-consent-inner {
    flex-direction: column;
    text-align: center;
    gap: 0.8rem;
    padding: 1rem;
  }
}
</style>
